import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducer import
import customizationReducer from './customizationReducer';
import accountReducer from './accountReducer';

//-----------------------|| COMBINE REDUCER ||-----------------------//
/**
 * reducer
 *
 * @summary Combines and configures Redux reducers for application state management.
 *
 * @description
 * Uses combineReducers to merge the account and customization reducers. Applies redux-persist to the account reducer for state persistence in local storage with a custom key prefix. Returns the combined reducer for use in the Redux store.
 *
 * @returns {Function} The combined root reducer function for Redux.
 *
 * @example
 * const store = createStore(reducer);
 */
const reducer = combineReducers({
    account: persistReducer(
        {
            key: 'account',
            storage,
            keyPrefix: 'berry-'
        },
        accountReducer
    ),
    customization: customizationReducer
});

export default reducer;
